import React from "react";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import axios from "axios";
import { getAccessToken } from "../utils/common";
import { toastState, loadingState } from "../utils/atom";
import Layout from "../components/Layout";
import Pager from "../components/Pager";
import SearchForm from "../components/SearchForm";
import CommentDetail from "./CommentDetail";

const Comment = () => {
    const [toast, setToast] = useRecoilState(toastState);
    const [loading, setLoading] = useRecoilState(loadingState);
    const { board_id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const idx = searchParams.get("idx") ?? null;
    const page = searchParams.get("page") ?? "1";
    const q = searchParams.get("q") ?? "";

    const [data, setData] = useState([]);
    const [pageHelper, setPageHelper] = useState({});

    useEffect(() => {
        fetch();
    }, [board_id, page, q]);

    async function fetch() {
        setLoading(true);
        try {
            const params = new URLSearchParams({ page, q });
            const url = `${process.env.REACT_APP_HOST}/comments/list/${board_id}?${params.toString()}`;
            const { data } = await axios({
                url,
                method: "GET",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Bearer ${getAccessToken()}`,
                },
            });

            if (data && data.code == 1) {
                setData(data.list ?? []);
                setPageHelper(data.page_helper ?? {});
            }
        } catch (error) {
            setToast({ isToast: true, message: "목록 로드 실패" });
        }
        setLoading(false);
    }

    function modalOpen(targetIdx) {
        setSearchParams({
            ...Object.fromEntries(searchParams.entries()),
            idx: targetIdx,
        });
    }

    function modalClose(isRefresh) {
        const params = Object.fromEntries(searchParams.entries());
        if (isRefresh) {
            fetch();
        }
        delete params.idx;
        setSearchParams(params);
    }

    function getThumbnail(url) {
        if (url && url.includes("cloudinary")) {
            const tmp = url.split("/upload");
            return tmp[0] + "/upload/w_100,h_100,c_fill" + tmp[1];
        }
        return url;
    }

    return (
        <Layout>
            <div className="row">
                <div className="col-12 mb-5">
                    <div className="table-responsive rounded bg-body p-3 shadow">
                        <SearchForm />
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    <th className="text-center text-nowrap" width={70}>
                                        레시피
                                    </th>
                                    <th className="text-center text-nowrap" width={50}></th>
                                    <th className="text-center text-nowrap">제목</th>
                                    <th className="text-center text-nowrap">댓글수</th>
                                    <th className="text-center text-nowrap">최근 댓글</th>
                                </tr>
                                {data.map((row) => (
                                    <tr key={row.target_idx}>
                                        <td className="text-center text-nowrap">{row.target_idx}</td>
                                        <td className="text-center p-0">
                                            {row.filename0 && (
                                                <img
                                                    src={getThumbnail(row.filename0)}
                                                    alt=""
                                                    width={38}
                                                    height={38}
                                                />
                                            )}
                                        </td>
                                        <td>
                                            <a
                                                href="#"
                                                className="hand link-underline text-nowrap"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    modalOpen(row.target_idx);
                                                }}
                                            >
                                                {row.title || "(삭제된 레시피)"}
                                            </a>
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-link p-0"
                                                onClick={() => modalOpen(row.target_idx)}
                                            >
                                                {row.comment_cnt || 0}
                                            </button>
                                        </td>
                                        <td className="text-center text-nowrap">{row.last_created}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <Pager pageHelper={pageHelper} />
                </div>
            </div>

            {idx && <CommentDetail modalClose={modalClose} idx={idx} boardId={board_id} />}
        </Layout>
    );
};

export default Comment;
